import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, Label, CardHeader,
  Card, CardBody } from 'reactstrap';
import { useLocation } from 'react-router-dom';

import { withSendRequest } from '../../main/hoc/withSendRequest';
import * as notify from '../../main/utils/notify';
import { getExperimentsRequestParams, ROLE_CSV_EXPORTER } from '../utils';
import { ErrorBoundary } from '../../main/hoc/errorboundary';
import { __env } from '../../envloader';
import useCheckRole from '../hooks/useCheckRole';

const FiltersResult = ({ allExperimentsCount, selectedExperiments, formControls, sendRequest,
  clearSelectedPulses, toggleCompareShotsModal, allVariables }) => {

  const { t } = useTranslation();

  const location = useLocation();

  const canAccess = useCheckRole( ROLE_CSV_EXPORTER );

  const [ filterVariables, setFilterVariables ] = useState(true);

  const onDownloadExperiments = async () => {
    const variablesIds = formControls.map(item => item.id);
    const { conditions, machines, variables } = getExperimentsRequestParams(location.search, allVariables);

    try {
      const { data: experiments } = await sendRequest('post', '/experiments/search', {
        conditions,
        machines,
        variables,
      });

      const experimentsIds = experiments?.items?.map((e) => e.id);

      const response = await sendRequest('post', '/reports/csv', {
        experiment_ids: experimentsIds,
        variable_ids: filterVariables ? variablesIds : null
      });
      if (response?.data?.csv_hash) {
        const link = document.createElement('a');
        link.href = __env.CATALOG_QT_API_URL+"reports/csv/"+response?.data?.csv_hash;
        link.download = 'csv';
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
      else {
        notify.error(t('filters_result.error_title'), t('filters_result.error_description'));
      }
    }
    catch (err) {
      notify.error(t('filters_result.error_title'), t('filters_result.error_description'));
    }
  };

  return (
    <>
      { (__env.DEMO_DASHBOARD || canAccess ) && <Card className='shadow-sm my-3'>
        <CardHeader>{t('filters_result.results_header')}</CardHeader>
        <CardBody>
          <div>
            <span>{allExperimentsCount}{' '}{t('filters_result.results_number_label')}</span>
          </div>

          <div className='d-flex flex-column align-items-start mt-1' >
            <div className={"custom-switch custom-control mb-1"}>
              <input
                id={'all-vs'}
                type='checkbox'
                checked={ filterVariables }
                disabled
                className={"custom-control-input"}
                onChange={() => setFilterVariables(!filterVariables)} />
              <Label for={'all-vs'} className={"custom-control-label"}>
                {t('filters_result.download_data_for_all_variables')}
              </Label>
            </div>
            <Button
              type='button'
              color='link'
              className='p-0'
              size='sm'
              onClick={() => { !__env.DEMO_DASHBOARD && onDownloadExperiments();} }
              disabled = { __env.DEMO_DASHBOARD }
            >
              {t('filters_result.download_time_dependent')}
            </Button>

          </div>
        </CardBody>
      </Card> }

      <Card className='shadow-sm my-3'>
        <CardHeader>{t('filters_result.selected_results_header')}</CardHeader>
        <CardBody>
          <p>{selectedExperiments.size}{' '}{t('filters_result.selected_results_number_label')}</p>
          <Row>
            <Col>
              <Button block onClick={toggleCompareShotsModal} disabled={selectedExperiments.size < 2} title={t("open_compare_shots_modal_button_tooltip")}>
                {t("open_compare_shots_modal_button")}
              </Button>
            </Col>
            <Col>
              <Button block onClick={clearSelectedPulses} disabled={selectedExperiments.size < 1} title={t("clear_selected_pulses_button_tooltip")}>
                {t("clear_selected_pulses_button")}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>

  );
};

FiltersResult.propTypes = {
  allExperimentsCount: PropTypes.number,
  selectedExperiments: PropTypes.object,
  formControls: PropTypes.array.isRequired,
  allVariables: PropTypes.object.isRequired,
  toggleCompareShotsModal: PropTypes.func,
  clearSelectedPulses: PropTypes.func,
  sendRequest: PropTypes.func.isRequired
};

export default compose(
  withSendRequest,
  ErrorBoundary((props) => props.t('filters_result'))
)(FiltersResult);
